import React from 'react';
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import orm from '../../models/orm'
import ProgramRow from '../programs/ProgramRow'
import CompositionRow from '../compositions/CompositionRow'
import PersonRow from '../compositions/PersonRow'
import SearchSection from './SearchSection'

let SearchResults = ({results}, context) => {

  const personItems = results.people.map(person =>
    <PersonRow person={person} key={person.id} viewBy={person.primaryKind} tagLabel={person.primaryKind} viewAsTable={false} skipLazyLoad={true}personVideoAttribute={false} tabindex="0"/>
  )
  const programItems = results.programs.map(program =>
    <ProgramRow program={program} key={program.id} viewAsTable={false} skipLazyLoad={true} tabindex="0"/>
  )
  const compositionItems = results.compositions.map(comp =>
    <CompositionRow composition={comp} key={comp.id} viewAsTable={false} skipLazyLoad={true} tabindex="0" personVideoAttribute={false} skipGenres={true} />
  )

  return (
    <div className="search_results">
    <SearchSection title="Artists" rows={personItems} />
    <SearchSection title="Compositions" rows={compositionItems} />
    <SearchSection title="Programs" rows={programItems} />
    {!results.noSearch && results.total == 0 && <div className="no_results">No results.</div>}
    </div>
  )
}

SearchResults.propTypes = {
  results: PropTypes.object,
}


const mapStateToProps = (state, ownProps) => {
  const search = ownProps.searchString.toLowerCase()

  if(search.length < 3) {
    return {
      results: {
        compositions: [],
        programs: [],
        people: [],
        noSearch: true
      }
    }
  }

  let results = {}
  const session = orm.session(state.data.orm)
  results.programs = session.Program.searchBy(search)
    .orderBy('date')
    .toRefArray().slice(0, 10)
    .map((props) => new session.Program(props))

  results.compositions = session.Composition.searchBy(search)
    .orderBy('title')
    .toRefArray().slice(0, 10)
    .map((props) => new session.Composition(props))

  results.people = session.Person.searchBy(search)
    .orderBy(['last_name', 'first_name'])
    .toRefArray().slice(0, 10)
    .map((props) => new session.Person(props))

  results.people.forEach((person) => {
    if(person.compositions.exists()) {
      person.primaryKind = 'composer'
    }
    else if(person.conducted_performances.exists()) {
      person.primaryKind = 'conductor'
    }
    else if(person.featured_performances.exists()) {
      person.primaryKind = 'performer'
    }
  })
  results.total = results.programs.length + results.compositions.length + results.people.length

  return {
    results: results
  }
}

export default connect(mapStateToProps, null)(SearchResults)